<script>
import generateClassNames from '../_mixins/generate-enum-classes';

/**
 * Component used to display any sort of text. Can apply set colors,
 * sizes, weights, and decorations keeping text consistent within an
 * application.
 */
export default {
  name: 'NtvText',

  mixins: [
    /**
     * Injects computed:
     *  classes
     *
     * Injects methods:
     *  generateClassName(prop, val)
     */
    generateClassNames
  ],

  props: {
    /**
     * The text that will be displayed.
     */
    text: {
      type: [String, Number],
      default: ''
    },
    /**
     * The string used for the title attribute.
     */
    toolTip: {
      type: String,
      default: null
    },
    /**
     * The size of the text.
     */
    size: {
      type: String,
      default: 'default'
    },
    /**
     * Font weight of the text. Options are light, thin, normal,
     * medium, and bold.
     */
    weight: {
      type: String,
      default: 'normal'
    },
    /**
     * Max width of the text. Used for ellipsis purposes.
     */
    maxWidth: {
      type: String,
      default: ''
    },
    /**
     * Color of the text. Options are dark, light, primary,
     * warning, danger, info, and success.
     */
    color: {
      type: String,
      default: 'default'
    },
    /**
     * The type of text decoration desired. Options are underline,
     * strikethrough, and overline.
     */
    textDec: {
      type: String,
      default: ''
    },
    /**
     * The type of text leading desired. Options are default, none, tight, and
     * loose.
     */
    textLeading: {
      type: String,
      default: ''
    },
    /**
     * Determines which HTML tag will be wrapped around the text. Typical
     * choices will be span, p, and h1 - h6 tags.
     */
    tag: {
      type: String,
      default: 'span'
    },
    /**
     * Add an ellipsis for when text gets cut off. maxWidth must
     * be set for this to work.
     */
    hasEllipsis: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    cTag() {
      // the 'tag' property has higher priority as isInline will be deprecated
      // shortly.
      if (this.tag) return this.tag;
      else {
        if (this.isInline) return 'span';
        else return 'p';
      }
    }
  },

  methods: {
    generateMaxWidth: function() {
      return this.maxWidth ? { maxWidth: this.maxWidth } : null;
    }
  },

  render(createElement) {
    return createElement(
      this.cTag,
      {
        class: 'ntv-text ' + this.classes,
        style: this.generateMaxWidth(),
        attrs: {
          title: this.toolTip === null ? '' : this.toolTip
        }
      },
      [this.text, this.$slots.default]
    );
  }
};
</script>
